
class FileUploadController {
    constructor($scope, $state, LoadedModel, $uibModal) {
        this._$state  = $state;
        this._$scope = $scope;
        this._$uibModal = $uibModal;
        this.model = LoadedModel;


        const defaultUploadText = "Please upload 3D model (*.igs or *.stl only) via selection or drag and drop";
        this.uploadText = defaultUploadText;

        $scope.$on('fileLoaded', (event, geometry) => {
            setTimeout(() => {
                LoadedModel.uploadFile(geometry);
            });
        });

        $scope.$on('meshError', (event, error) => {
            this.uploadText = error ? error : defaultUploadText;
            this._$scope.$apply();
        });
    }

    hideButton() {
        if (this._$state.current.name === 'home') {
            return false;
        }
        return true;
    }

    areConditionsAccepted() {
      return localStorage.getItem('isAgreementAccepted') === 'yes';
    }

    acceptAgreement() {
      return localStorage.setItem('isAgreementAccepted', 'yes');
    }

    uploadFiles(files) {
        if (files.length) {
            const file = files[0];
            if (file.size > 15728640) {
                this._$scope.$broadcast('meshError', 'File is too big, maximum file size is 15MB.');
            } else {
                this.model.uploadFile({
                    fileName: file.name,
                    rawData: file
                });
            }

        }
        this._$scope.files = files;
    }
}

FileUploadController.$inject = ['$scope', '$state', 'LoadedModel', '$uibModal'];

export default FileUploadController;



// WEBPACK FOOTER //
// ./client/app/common/file-upload/file-upload.controller.js